import { Form, Input, Modal, Spin } from 'antd';
import React, { Component } from 'react';
import '../style.css';

class BlackHoleForm extends Component {
  componentDidUpdate = async (prevProps) => {
    const { data: pd } = prevProps;
    const { data: d, form } = this.props;

    if (d && d.keyword !== pd.keyword) form.setFieldsValue(d);
  };

  handleCancelModal = () => {
    const { onCancel, form } = this.props;

    form.resetFields();
    onCancel();
  };

  render() {
    const { visible, onCreate, form, flagCreateOrUpdateForm, loading } = this.props;
    const { getFieldDecorator } = form;
    const okText = flagCreateOrUpdateForm ? 'เพิ่ม' : 'แก้ไข';
    const title = `${okText} Blackhole Keyword`;

    return (
      <Modal
        cancelText="ยกเลิก"
        maskClosable={false}
        okText={okText}
        onCancel={this.handleCancelModal}
        onOk={onCreate}
        style={{ top: 20 }}
        title={title}
        visible={visible}
      >
        <Spin spinning={loading} tip="กำลังบันทึกข้อมูล...">
          <Form className="blackhole_form">
            {getFieldDecorator('id')(<Input type="hidden" />)}
            <Form.Item label="Keyword">
              {getFieldDecorator('keyword', {
                rules: [
                  {
                    message: 'กรุณากรอก Blackhole Keyword ที่ต้องการ',
                    required: true,
                  },
                ],
              })(<Input />)}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

export default Form.create({ name: 'blackhole_form' })(BlackHoleForm);



// WEBPACK FOOTER //
// ./src/containers/Keyword/Blackhole/form.js